export enum OrganizationCategoryAction {
    ORGANIZATION_CATEGORY_STATE = 'STATE',
    ORGANIZATION_CATEGORY_REGION = 'REGION',
    ORGANIZATION_CATEGORY_MUNICIPALITY = 'MUNICIPALITY',
    ORGANIZATION_CATEGORY_OTHER = 'OTHER',
}

export enum Targets {
    CITIZEN = 'CITIZEN',
    COMPANY = 'COMPANY',
    AUTHORITY = 'AUTHORITY',
}
